import _ from 'lodash';
window._ = _;

// Build commit, defined by Vite (see vite.config.ts); absent under Jest.
/* global __BUILD_COMMIT__ */
window.__ZORGMEE_BUILD__ = typeof __BUILD_COMMIT__ === 'undefined' ? 'dev' : __BUILD_COMMIT__;

// CSS - all styles through Vite
import 'vendor-stylesheets/semantic_ui_less/compiled.css';
import 'stylesheets/semantic-ui-overrides.scss';
import 'stylesheets/app-styles.scss';

import Rails from '@rails/ujs';
if (!window._rails_loaded) Rails.start();

import '../parametered_routes';
import '../i18n';
import '../airbrake'
import browserUpdate from 'browser-update';
import 'cable';

// React-Rails UJS component mounting
// Replace Webpack's require.context with Vite's import.meta.glob
const componentModules = import.meta.glob('../components/**/*.{js,jsx}', { eager: true });

const componentContext = (name) => {
  // react_ujs calls this with paths like "MainApp" or "dossiers/DossierList"
  const candidates = [
    `../components/${name}.jsx`,
    `../components/${name}.js`,
    `../components/${name}/index.jsx`,
    `../components/${name}/index.js`,
  ];

  for (const path of candidates) {
    if (componentModules[path]) {
      return componentModules[path].default || componentModules[path];
    }
  }

  // Fallback: search all modules for a matching filename
  for (const [modulePath, mod] of Object.entries(componentModules)) {
    const segments = modulePath.replace('../components/', '').replace(/\.(jsx|js)$/, '');
    if (segments === name || segments === `${name}/index`) {
      return mod.default || mod;
    }
  }

  console.error(`Could not find component: ${name}`);
  return null;
};

import ReactRailsUJS from 'react_ujs';
ReactRailsUJS.getConstructor = (name) => componentContext(name);

// Browser update notification
document.addEventListener('DOMContentLoaded', function(event) {
  browserUpdate({
    l: I18n.locale,
    style: 'corner',
    required: {
      e: -2, f: -2, o: -2, o_a: -2, s: -1,
      c: -2, y: -2, v: -2, uc: -2, samsung: -2
    }
  });
});
